import { render, staticRenderFns } from "./SubcategoryView.vue?vue&type=template&id=2b77d78c&scoped=true&"
import script from "./SubcategoryView.vue?vue&type=script&lang=js&"
export * from "./SubcategoryView.vue?vue&type=script&lang=js&"
import style0 from "./SubcategoryView.vue?vue&type=style&index=0&id=2b77d78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77d78c",
  null
  
)

export default component.exports